import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Result } from 'antd';
import styles from './index.module.scss';

interface ICreateResultProps {
  email: string;
  password: string;
}
export const CreateResult: FC<ICreateResultProps> = props => {
  const { email, password } = props;
  const { t } = useTranslation();
  return (
    <Result
      status={'success'}
      title={t('AdminPage.userCreated')}
      subTitle={t('AdminPage.userCreatedDescription')}
      extra={
        <dl className={styles.props}>
          <div>
            <dt>{t('Common.email')}</dt>
            <dd>{email}</dd>
          </div>
          <div>
            <dt>{t('Common.password')}</dt>
            <dd>{password}</dd>
          </div>
        </dl>
      }
    />
  );
};

export default CreateResult;
